/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
// oxlint-disable-next-line no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JiraSoftwareBoardAri } from '@atlassian/ari/jira-software/board';

import type { Queries } from './BoardSettingsSwitcher.tsx';
import parameters from './__generated__/BoardSettingsSwitcherQuery.graphql.ts';

type BoardSettingsSwitcherEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const classicBoardSettingsEntryPoint: EntryPoint<
	BoardSettingsSwitcherEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<BoardSettingsSwitcherEntryPointComponent>(
		/* webpackChunkName: "async-classic-board-settings-entrypoint" */ './BoardSettingsSwitcher.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { boardId },
			},
		},
		tenantContext: { cloudId },
	}: EntryPointRouteParams) => {
		const boardAri = JiraSoftwareBoardAri.create({
			siteId: cloudId,
			boardId: String(boardId),
		}).toString();

		return {
			queries: {
				queryRef: {
					parameters,
					variables: { boardId: boardAri },
					options: { fetchPolicy: 'store-or-network' as const },
				},
			},
		};
	},
});
